import { ApolloCache, Reference } from "@apollo/client"
import { TRANSPORTERPRICE_FRAGMENT } from "../fragment/transporterPrice"

export const updateCacheTransporterPrice = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      transporterPrices(existing = []) {
        const newTransporterPriceRef = cache.writeFragment({
          data: entryData,
          fragment: TRANSPORTERPRICE_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newTransporterPriceRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newTransporterPriceRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) =>
                el?.__ref !== newTransporterPriceRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newTransporterPriceRef
            }
            return items
        }
      },
      aggregateTransporterPrice(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
